import styled from 'styled-components'

import { useClock } from 'hooks'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  flex: 1;
`

const Time = styled.div`
  font-size: 15vw;
  font-weight: 600;
`

export const Clock = () => {
  const time = useClock()

  return (<Container><Time>{time[0][0]}:{time[0][1]}</Time></Container>)
}
